export const directions = {
    INBOUND: 0,
    OUTBOUND: 1,
    OTHER: 2,
}